/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./listViewPage.vue?vue&type=template&id=24b0b7ea"
import script from "./listViewPage.vue?vue&type=script&lang=js"
export * from "./listViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports